import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/identity-and-access/api-tokens/new/permissions")({
  staticData: {
    title: "apiTokens.panel.permissions",
  },
});
